import axios from "axios";
import { API_URL } from "../Config/environment"

export async function getAllBlogs() {
  const resp = await axios.get(`${API_URL}/blog/home-page?page=1&limit=6`);
          // console.log(resp)
  return resp?.data?.data ?? [];
}

export async function getBlogById(blog_id) {
  try {
    const resp = await axios.get(`${API_URL}/blog/home-page/${blog_id}`);
    // console.log("Blog Detail Response:", resp);
     return resp?.data?.data?.blog ?? null;// adjust if your API wraps it differently
  } catch (error) {
    console.error("Error fetching blog by ID:", error);
    throw error;
  }
}
